export default __webpack_public_path__ + "static/media/box-front.61472700.webp";